import { ENDPOINTS } from "../config/endpoints";

// Umpires keep a single-step form — name / nationality / role only.
// Contact + location fields (state, city, email, mobile, whatsapp_ok)
// were dropped per operator feedback: they were rarely populated and
// added friction to umpire creation without any consumer of the data.
// The columns still exist on the model so legacy rows stay intact;
// they're just unsurfaced in the UI.
export const umpireSchema = {
  steps: [
    {
      title: "Umpire Details",
      fields: [
        {
          name: "name",
          type: "text",
          displayName: "First Name",
          required: true,
        },
        {
          name: "middle_name",
          type: "text",
          displayName: "Middle Name",
        },
        {
          name: "last_name",
          type: "text",
          displayName: "Last Name",
        },
        {
          name: "short_name",
          type: "text",
          displayName: "Display Name",
        },
        {
          name: "date_of_birth",
          type: "text",
          inputType: "date",
          displayName: "Date of Birth",
        },
        {
          name: "nationality",
          type: "select",
          displayName: "Nationality",
          fetch: ENDPOINTS.coredata.nationalities,
        },
        {
          name: "role",
          type: "select",
          displayName: "Role",
          optionsKey: "ROLES",
        },
      ],
    },
  ],
};
